import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table, Modal } from 'antd';
import throttle from 'lodash/throttle';
import isEqual from 'lodash/isEqual';

import {
  getAllTags,
  getAllGroups,
  createTag,
  updateTag,
  deleteTag,
} from '../../../../../data/redux/member_details/actions';
import { pageChanged } from '../../../../../data/redux/page_details/actions';

import { APP_PAGES } from '../../../../../data/config/constants';
import { filterArrayBySearchText, showMessage } from '../../../../../data/config/utils';
import { IMG_ERROR } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import TableCellAction from '../../../components/tablecellaction';
import CustomHeader from '../../../../../components/customheader';
import CommonForm from '../../../../../components/commonform';
import ShowMessage from '../../../../../components/showmessage';

class Tags extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      search_text: "",
      filtered_tags: props.tags,
      current_tag: {},
      modal_data: {
        title: "",
        show_create_tag: false,
        show_edit_tag: false,
      },
    };
    this.throttleFilterTagsBySearchKey = throttle(filterArrayBySearchText, 300);
    this.columns = this.getTagsTableColumns();
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.pageChanged(APP_PAGES.TAGS, APP_PAGES.MEMBERS);
    actions.getAllTags();
    actions.getAllGroups();
  }

  componentDidUpdate(prevProps) {
    const { tags } = this.props;
    const { search_text } = this.state;
    if (!isEqual(prevProps.tags, tags) || prevProps.tags.length !== tags.length) {
      this.setState({
        filtered_tags: search_text.length === 0 ? tags : this.throttleFilterTagsBySearchKey(search_text, tags, "name"),
      });
    }
  }

  componentWillUnmount() {
    if (this.throttleFilterTagsBySearchKey)
      this.throttleFilterTagsBySearchKey.cancel();
  }

  getTagsTableColumns = () => {
    const columns = [
      {
        title: 'Tag Name',
        dataIndex: 'name',
        render: tag => (<span className="ori-border-primary ori-lr-pad-10 ori-tb-pad-3 ori-border-radius-4 ori-font-primary ori-font-11">{tag}</span>)

      },
      {
        title: 'Description',
        dataIndex: 'description',
      },
      {
        title: 'Group',
        dataIndex: 'group',
      },
      {
        title: 'Action',
        dataIndex: 'action',
        align: 'center',
        render: (item, record) => {
          return (
            <TableCellAction align_center show_edit show_delete delete_popconfirm_title="Are you sure delete this agent?" handleEditClick={this.onClickEditTag.bind(this, record)} handleDeleteClick={this.deleteTag.bind(this, record)} />
          );
        }
      }
    ];
    return columns;
  };

  handleTagsSearch = event => {
    const search_text = event.target.value.trim();
    const { tags } = this.props;
    this.setState({
      search_text,
      filtered_tags: search_text.length === 0 ? tags : this.throttleFilterTagsBySearchKey(search_text, tags, "name"),
    });
  };

  closeModal = () => {
    this.setState({
      current_tag: {},
      modal_data: {
        title: "",
        show_create_tag: false,
        show_edit_tag: false,
      }
    });
  };

  onClickAddTag = () => {
    this.setState({
      modal_data: {
        title: "Create New Tag",
        show_create_tag: true,
        show_edit_tag: false,
      }
    });
  };

  onClickEditTag = current_tag => {
    this.setState({
      current_tag,
      modal_data: {
        title: "Edit Tag",
        show_create_tag: false,
        show_edit_tag: true,
      }
    });
  };

  createTag = () => {
    const { actions } = this.props;
    actions.createTag(this.state.current_tag, this.closeModal);
  };

  updateTag = () => {
    const { actions } = this.props;
    actions.updateTag(this.state.current_tag, this.closeModal);
  };

  deleteTag = tag => {
    const { actions } = this.props;
    if (tag._id) {
      actions.deleteTag({ _id: tag._id });
    } else {
      showMessage('error', 'tag id is missing');
    }
  };

  onChangeCurrentTag = event => {
    this.setState({
      current_tag: {
        ...this.state.current_tag,
        [event.target.name]: event.target.value
      }
    });
  };

  onChangeGroup = group => {
    this.setState({
      current_tag: {
        ...this.state.current_tag,
        group
      }
    })
  };

  renderCommonForm = () => {
    const { modal_data, current_tag } = this.state;
    const { groups, tag_updating } = this.props;
    if (modal_data.show_create_tag || modal_data.show_edit_tag) {
      const first_input_props = {
        title: "Tag",
        placeholder: "Enter tag name",
        name: "name",
        value: current_tag.name,
        onChange: this.onChangeCurrentTag
      };
      const first_textarea_props = {
        title: "Description",
        placeholder: "write something about this tag ...",
        name: "description",
        value: current_tag.description,
        onChange: this.onChangeCurrentTag
      };
      const first_select_props = {
        title: "Group",
        placeholder: "select group",
        value: current_tag.group,
        options: groups,
        is_option_object_type: true,
        allow_clear: true,
        value_key: "name",
        onChange: this.onChangeGroup
      };
      const modal_footer_props = {
        loading: tag_updating,
        button_ok_text: modal_data.show_create_tag ? (tag_updating ? "Creating" : "Create") : (tag_updating ? "Updating" : "Update"),
        handleCancelClick: this.closeModal,
        handleOkClick: modal_data.show_create_tag ? this.createTag : this.updateTag
      };
      return (
        <CommonForm show_first_input first_input_props={first_input_props} show_first_textarea first_textarea_props={first_textarea_props} show_first_select first_select_props={first_select_props} modal_footer_props={modal_footer_props} />
      );
    }
  };

  render() {
    const { modal_data, filtered_tags } = this.state;
    const { screen_width, tags_loading, tags_loaded } = this.props;
    if (tags_loading && !tags_loaded) {
      return (
        <div className="ori-full-parent-height">
          <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
          <div className="ori-pad-10">
            <CardRowTableLoader />
          </div>
        </div>
      );
    } else if (!tags_loading && tags_loaded) {
      return (
        <div className="ori-lr-pad-10">
          <CustomHeader title="Tags" search_placeholder="search tags" onChangeSearch={this.handleTagsSearch} first_button_type="primary" first_button_text="+ Add Tag" onClickFirstButton={this.onClickAddTag} bottom_bordered show_first_button show_search />
          <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 450 }} pagination={{ pageSize: 20 }} size={screen_width < 768 ? "small" : "middle"} rowKey='_id' columns={this.columns} dataSource={filtered_tags} />
          <Modal className="ori-modal-primary" title={modal_data.title} footer={null} maskClosable={false} visible={modal_data.show_create_tag || modal_data.show_edit_tag} onCancel={this.closeModal}>
            {this.renderCommonForm()}
          </Modal>
        </div>
      );
    } else if (!tags_loading && !tags_loaded) {
      return (
        <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load tags details. please check your internet connection and reload the page." height={150} width={150} />
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    screen_height: state.page_details.device_data.screen_height,
    tags: state.member_details.tags,
    tags_loading: state.member_details.loaders.tags_loading,
    tags_loaded: state.member_details.loaders.tags_loaded,
    tag_updating: state.member_details.loaders.tag_updating,
    groups: state.member_details.groups,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({
      pageChanged,
      getAllTags,
      createTag,
      updateTag,
      deleteTag,
      getAllGroups
    },
      dispatch),
  };
};

Tags.propTypes = {
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  tags: PropTypes.array,
  tags_loading: PropTypes.bool,
  tags_loaded: PropTypes.bool,
  tag_updating: PropTypes.bool,
  groups: PropTypes.array,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Tags);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/tags/index.js